import React from 'react';
import '../../admin-stats.css';

function ActivityStatsChart({ activityData, loading }) {
  if (loading || !activityData) {
    return (
      <div className="stats-section">
        <h2>Activity Statistics</h2>
        <div className="loading">Loading activity data...</div>
      </div>
    );
  }

  const stats = activityData;

  return (
    <div className="stats-section">
      <h2>🗣️ Activity Statistics</h2>
      
      <div className="stats-grid">
        <div className="stat-box">
          <h3>Activity Summary</h3>
          <div className="breakdown-list">
            <div className="breakdown-item">
              <span className="label">Total Posts</span>
              <span className="value">{stats.summary?.total || 0}</span>
            </div>
            <div className="breakdown-item">
              <span className="label">Locked Posts</span>
              <span className="value warning">{stats.summary?.locked || 0}</span>
            </div>
            <div className="breakdown-item">
              <span className="label">Avg Comments/Post</span>
              <span className="value">{stats.summary?.avgCommentDepth || 0}</span>
            </div>
            <div className="breakdown-item">
              <span className="label">Avg Reactions/Post</span>
              <span className="value">{stats.summary?.avgReactionsPerPost || 0}</span>
            </div>
          </div>
        </div>

        <div className="stat-box">
          <h3>By Type</h3>
          <div className="breakdown-list">
            {stats.byType && Object.entries(stats.byType).map(([type, data]) => (
              <div key={type} className="breakdown-item">
                <span className="label">{type}</span>
                <span className="value">{data.total}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="stat-box">
          <h3>Engagement Metrics</h3>
          <div className="breakdown-list">
            {stats.engagementMetrics && (
              <>
                <div className="breakdown-item">
                  <span className="label">Total Comments</span>
                  <span className="value">{stats.engagementMetrics.totalReactions || 0}</span>
                </div>
                <div className="breakdown-item">
                  <span className="label">Locked Rate</span>
                  <span className="value">{(stats.engagementMetrics.lockedPostRate * 100).toFixed(2)}%</span>
                </div>
                <div className="breakdown-item">
                  <span className="label">Avg Depth</span>
                  <span className="value">{stats.engagementMetrics.avgCommentDepth || 0}</span>
                </div>
              </>
            )}
          </div>
        </div>

        <div className="stat-box">
          <h3>This Period</h3>
          <div className="breakdown-list">
            <div className="breakdown-item">
              <span className="label">New Activity</span>
              <span className="value">{stats.summary?.newThisPeriod || 0}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="stat-box full-width">
        <h3>Top Posters</h3>
        {stats.topPosters && stats.topPosters.length > 0 ? (
          <div className="table-container">
            <table className="stats-table">
              <thead>
                <tr>
                  <th>Display Name</th>
                  <th>Post Count</th>
                </tr>
              </thead>
              <tbody>
                {stats.topPosters.map((poster, idx) => (
                  <tr key={idx}>
                    <td>{poster.displayName}</td>
                    <td className="text-right">{poster.postCount}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="empty-state">No activity data available</p>
        )}
      </div>

      {stats.timeSeries && stats.timeSeries.length > 0 && (
        <div className="stat-box full-width">
          <h3>Activity Timeline</h3>
          <div className="timeline-container">
            {stats.timeSeries.map((item, idx) => (
              <div key={idx} className="timeline-item">
                <span className="timeline-date">{item.date}</span>
                <span className="timeline-value">{item.newActivity} new</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default ActivityStatsChart;
